(function(){
  "use strict";
  var money = function(c){ return "$" + (c/100).toFixed(2); };
  function $(id){ return document.getElementById(id); }

  // ---- toast ----
  var tTimer;
  window.HOWtoast = function(msg){
    var el = $("toast"); if(!el) return;
    el.textContent = msg; el.classList.add("on");
    clearTimeout(tTimer); tTimer = setTimeout(function(){ el.classList.remove("on"); }, 2800);
  };

  // ---- mobile nav ----
  var hb = $("hambBtn"), mo = $("mobOv");
  if(hb) hb.addEventListener("click", function(){ $("mobNav").classList.toggle("on"); $("mobOv").classList.toggle("on"); });
  if(mo) mo.addEventListener("click", function(){ $("mobNav").classList.remove("on"); mo.classList.remove("on"); });

  // ---- cart drawer ----
  function openCart(){ var d=$("cartDrawer"),o=$("cartOv"); if(d){ renderDrawer(); d.classList.add("on"); o.classList.add("on"); document.body.style.overflow="hidden"; } }
  function closeCart(){ var d=$("cartDrawer"),o=$("cartOv"); if(d){ d.classList.remove("on"); o.classList.remove("on"); document.body.style.overflow=""; } }
  var cb=$("cartBtn"); if(cb) cb.addEventListener("click", openCart);
  var cx=$("cartX"); if(cx) cx.addEventListener("click", closeCart);
  var co=$("cartOv"); if(co) co.addEventListener("click", closeCart);

  function setCount(n){ document.querySelectorAll(".cart-count").forEach(function(b){ b.textContent=n; b.classList.toggle("on", n>0); }); }

  function renderDrawer(){
    var bd=$("cartBd"), ft=$("cartFt"); if(!bd) return;
    fetch("/cart.js").then(function(r){return r.json();}).then(function(cart){
      setCount(cart.item_count);
      if(!cart.items.length){
        bd.innerHTML='<div class="cart-empty-s"><div class="ci">🛒</div><p>Your cart is empty.<br><small>Add something exceptional.</small></p></div>';
        if(ft) ft.style.display="none"; return;
      }
      bd.innerHTML = cart.items.map(function(it){
        var img = it.image ? '<img src="'+it.image+'" alt="" style="width:100%;height:100%;object-fit:cover">' : '🐾';
        return '<div class="ci-row">'+
          '<div class="ci-thumb">'+img+'</div>'+
          '<div class="ci-info">'+
            '<div class="ci-name">'+it.product_title+'</div>'+
            '<div class="ci-price">'+money(it.price)+'</div>'+
            '<div class="ci-qty">'+
              '<button class="qbtn" data-key="'+it.key+'" data-q="'+(it.quantity-1)+'">−</button>'+
              '<span class="qn">'+it.quantity+'</span>'+
              '<button class="qbtn" data-key="'+it.key+'" data-q="'+(it.quantity+1)+'">+</button>'+
              '<span class="ci-rm" data-key="'+it.key+'" data-q="0">Remove</span>'+
            '</div>'+
          '</div>'+
        '</div>';
      }).join("");
      $("cartTot").textContent = money(cart.total_price);
      if(ft) ft.style.display="block";
    });
  }

  // delegate qty buttons
  document.addEventListener("click", function(e){
    var t = e.target.closest("[data-key]");
    if(t){ changeQty(t.getAttribute("data-key"), parseInt(t.getAttribute("data-q"),10)); }
    var a = e.target.closest("[data-add]");
    if(a){ addToCart(a.getAttribute("data-add")); }
  });

  function changeQty(key, q){
    fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:key,quantity:q})})
      .then(function(r){return r.json();}).then(function(){ renderDrawer(); });
  }
  function addToCart(variantId){
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:variantId,quantity:1})})
      .then(function(r){return r.json();}).then(function(){ HOWtoast("Added to cart"); openCart(); });
  }
  window.HOWopenCart = openCart;
  setCount(document.querySelector(".cart-count") ? parseInt(document.querySelector(".cart-count").textContent,10)||0 : 0);

  // ---- hero slider ----
  var track = $("heroTrack");
  if(track){
    var hi=0, dots=document.querySelectorAll(".hdot"), hn=document.querySelectorAll(".hero-slide").length;
    function apply(){ track.style.transform="translateX(-"+(hi*100)+"%)"; dots.forEach(function(d,i){ d.classList.toggle("on", i===hi); }); }
    window.HOWslide=function(d){ hi=(hi+d+hn)%hn; apply(); };
    window.HOWgoSlide=function(n){ hi=n; apply(); };
    var ht=setInterval(function(){ HOWslide(1); },6000);
    track.addEventListener("mouseenter",function(){ clearInterval(ht); });
    track.addEventListener("mouseleave",function(){ ht=setInterval(function(){ HOWslide(1); },6000); });
    dots.forEach(function(d,i){ d.addEventListener("click",function(){ HOWgoSlide(i); }); });
  }

  // ---- pet tabs (home) ----
  document.querySelectorAll(".ptab").forEach(function(tab){
    tab.addEventListener("click", function(){
      document.querySelectorAll(".ptab").forEach(function(t){ t.classList.remove("on"); });
      tab.classList.add("on");
      var pet = tab.getAttribute("data-pet");
      document.querySelectorAll(".qgroup").forEach(function(g){ g.style.display = g.getAttribute("data-pet")===pet ? "grid" : "none"; });
    });
  });

  // ---- newsletter (home / club) ----
  document.querySelectorAll("form[data-newsletter]").forEach(function(f){
    f.addEventListener("submit", function(e){
      e.preventDefault();
      HOWtoast("Welcome to the Whisker Club — check your inbox to confirm.");
      f.reset();
    });
  });
})();
